<template>
  <span class="do-not-collapse pointer list-expander text-small text-muted pull-right" @click="expandAllToggle">Expand All</span>
</template>

<script>
export default {
  data() {
    return {
      expanded: false,
    };
  },
  methods: {
    expandAllToggle(){
      if(this.expanded){
        this.expanded = false
        $('.js-task-details-collapse').removeClass('show')
      } else {
        this.expanded = true
        $('.js-task-details-collapse').addClass('show')
      }
    }
  }
};
</script>
